import React, { Component } from "react";
const { Provider, Consumer } = React.createContext();

class IsFromSearchContextProvider extends Component {
    render() {
        return (
            <Provider value={this.props.isFromSearch}>
                {this.props.children}
            </Provider>
        )
    }
}

export { IsFromSearchContextProvider, Consumer as IsFromSearchContextConsumer };